
















import { Component, Prop, Watch } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'

@Component({
  name: 'HsPagination',
})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  // #region variables
  @Prop({ default: 0 }) value: number
  @Prop({ default: 0 }) size: number
  @Prop({ default: 0 }) total: number
  @Prop({ default: false }) justifySpaceBetween: boolean

  currentPage: number | null = null

  @Watch('value')
  onValue(val) {
    this.currentPage = val
  }

  mounted() {
    this.currentPage = this.value
  }

  // #endregion
  // #region hooks
  // #endregion
  // #region methods

  get startItem() {
    return (this.currentPage - 1) * this.size + 1
  }

  get endItem() {
    return this.currentPage * this.size > this.total ? this.total : this.currentPage * this.size
  }

  isDisabled(target) {
    return target === 0 || target > Math.ceil(this.total / this.size)
  }

  next() {
    this.$emit('input', this.value + 1)
  }

  prev() {
    this.$emit('input', this.value - 1)
  }

  // #endregion
  // #region watches
  // #endregion
}
